import Service from 'react-reservice';

import experienceApi, { IRegisterDemoAccountParams } from '@webtrader/core/api/experienceDemo';
import { IApiError } from '@webtrader/core/request/api';
import { ECommonResponseCode, mapResponseCodeToMessage } from '@webtrader/core/request/message';

interface IResetPasswordFormServiceContext {
  loading: boolean;
}

const defaultContext: IResetPasswordFormServiceContext = {
  loading: false
};

class ResetPasswordFormService extends Service<IResetPasswordFormServiceContext> {
  constructor() {
    super();
    this.context = {
      ...defaultContext
    };
  }

  public submitForm = async (params: IRegisterDemoAccountParams) => {
    try {
      this.context.loading = true;

      const { result, code } = await experienceApi.resetPasswordDemoAccount(params);
      if (code === ECommonResponseCode.OK && result) {
        return {
          success: true,
          message: 'Success',
          result
        };
      }
      return {
        success: false,
        message: 'An error occurred'
      };
    } catch (error) {
      const { code, message } = error as IApiError;
      return {
        success: false,
        message: mapResponseCodeToMessage(code, message)
      };
    } finally {
      this.context.loading = false;
    }
  };
}

export const resetPasswordFormService = new ResetPasswordFormService();
